<script>
export default {
  props: ["project"],
};
</script>

<template>
  <div class="card-container">
    <a
      :href="project.link"
      target="_blank"
      to="/projects/single-project"
      class="rounded-xl shadow-lg hover:shadow-xl cursor-pointer bg-secondary-light dark:bg-ternary-dark"
      aria-label="Single Project"
      style="display: flex; flex-direction: column; height: 100%; margin: 0px"
    >
      <div style="flex: 1 1 0%; position: relative">
        <img
          :src="project.img"
          :alt="project.title"
          style="
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
          "
        />
      </div>
      <div class="text-center px-4 py-6">
        <p
          class="font-general-semibold text-xl text-ternary-dark dark:text-ternary-light font-semibold mb-2 underline hover:underline hover:text-indigo-600 dark:hover:text-indigo-300"
        >
          {{ project.title }}
        </p>
        <span
          class="font-general-medium text-lg text-ternary-dark dark:text-ternary-light"
          >{{ project.category }}</span
        >
      </div>
    </a>
  </div>
</template>

<style scoped>
.card-container {
  box-sizing: border-box;
  padding: 5px;
}

@media (max-width: 600px) {
  .card-container {
    padding: 15px;
  }
  a {
    margin: 5px;
  }
}
</style>

<style lang="scss" scoped></style>
